export const SHOPS_FEATURE_KEY = "shops";
